import { ReactComponent as ForwardRef } from './svgs/add.svg.js';
import { ReactComponent as ForwardRef$1 } from './svgs/agenda.svg.js';
import { ReactComponent as ForwardRef$2 } from './svgs/alcohol.svg.js';
import { ReactComponent as ForwardRef$3 } from './svgs/ambulance.svg.js';
import { ReactComponent as ForwardRef$4 } from './svgs/american-express.svg.js';
import { ReactComponent as ForwardRef$5 } from './svgs/ampoul.svg.js';
import { ReactComponent as ForwardRef$6 } from './svgs/analytics.svg.js';
import { ReactComponent as ForwardRef$7 } from './svgs/app-shop.svg.js';
import { ReactComponent as ForwardRef$8 } from './svgs/apple.svg.js';
import { ReactComponent as ForwardRef$9 } from './svgs/appreciation.svg.js';
import { ReactComponent as ForwardRef$a } from './svgs/asterisk.svg.js';
import { ReactComponent as ForwardRef$b } from './svgs/badge-1.svg.js';
import { ReactComponent as ForwardRef$c } from './svgs/badge.svg.js';
import { ReactComponent as ForwardRef$d } from './svgs/band-aid.svg.js';
import { ReactComponent as ForwardRef$e } from './svgs/bandage.svg.js';
import { ReactComponent as ForwardRef$f } from './svgs/barcode.svg.js';
import { ReactComponent as ForwardRef$g } from './svgs/battery.svg.js';
import { ReactComponent as ForwardRef$h } from './svgs/bed.svg.js';
import { ReactComponent as ForwardRef$i } from './svgs/block.svg.js';
import { ReactComponent as ForwardRef$j } from './svgs/blood-test.svg.js';
import { ReactComponent as ForwardRef$k } from './svgs/bone.svg.js';
import { ReactComponent as ForwardRef$l } from './svgs/bookmark.svg.js';
import { ReactComponent as ForwardRef$m } from './svgs/box-1.svg.js';
import { ReactComponent as ForwardRef$n } from './svgs/box.svg.js';
import { ReactComponent as ForwardRef$o } from './svgs/brightness-1.svg.js';
import { ReactComponent as ForwardRef$p } from './svgs/brightness.svg.js';
import { ReactComponent as ForwardRef$q } from './svgs/browser-1.svg.js';
import { ReactComponent as ForwardRef$r } from './svgs/browser-11.svg.js';
import { ReactComponent as ForwardRef$s } from './svgs/browser.svg.js';
import { ReactComponent as ForwardRef$t } from './svgs/calculator.svg.js';
import { ReactComponent as ForwardRef$u } from './svgs/calendar-1.svg.js';
import { ReactComponent as ForwardRef$v } from './svgs/calendar.svg.js';
import { ReactComponent as ForwardRef$w } from './svgs/cancel.svg.js';
import { ReactComponent as ForwardRef$x } from './svgs/cart.svg.js';
import { ReactComponent as ForwardRef$y } from './svgs/cells.svg.js';
import { ReactComponent as ForwardRef$z } from './svgs/chat-1.svg.js';
import { ReactComponent as ForwardRef$A } from './svgs/chat-2.svg.js';
import { ReactComponent as ForwardRef$B } from './svgs/chat-3.svg.js';
import { ReactComponent as ForwardRef$C } from './svgs/chat-5.svg.js';
import { ReactComponent as ForwardRef$D } from './svgs/chat-6.svg.js';
import { ReactComponent as ForwardRef$E } from './svgs/chat-7.svg.js';
import { ReactComponent as ForwardRef$F } from './svgs/chat4.svg.js';
import { ReactComponent as ForwardRef$G } from './svgs/checked.svg.js';
import { ReactComponent as ForwardRef$H } from './svgs/clock.svg.js';
import { ReactComponent as ForwardRef$I } from './svgs/closed.svg.js';
import { ReactComponent as ForwardRef$J } from './svgs/cloud-computing.svg.js';
import { ReactComponent as ForwardRef$K } from './svgs/coffee-cup.svg.js';
import { ReactComponent as ForwardRef$L } from './svgs/coins.svg.js';
import { ReactComponent as ForwardRef$M } from './svgs/compact-disc.svg.js';
import { ReactComponent as ForwardRef$N } from './svgs/compass.svg.js';
import { ReactComponent as ForwardRef$O } from './svgs/computer.svg.js';
import { ReactComponent as ForwardRef$P } from './svgs/conversation-1.svg.js';
import { ReactComponent as ForwardRef$Q } from './svgs/conversation-2.svg.js';
import { ReactComponent as ForwardRef$R } from './svgs/conversation.svg.js';
import { ReactComponent as ForwardRef$S } from './svgs/credit-card-1.svg.js';
import { ReactComponent as ForwardRef$T } from './svgs/credit-card-2.svg.js';
import { ReactComponent as ForwardRef$U } from './svgs/credit-card-3.svg.js';
import { ReactComponent as ForwardRef$V } from './svgs/credit-card-4.svg.js';
import { ReactComponent as ForwardRef$W } from './svgs/credit-card-5.svg.js';
import { ReactComponent as ForwardRef$X } from './svgs/credit-card.svg.js';
import { ReactComponent as ForwardRef$Y } from './svgs/cup.svg.js';
import { ReactComponent as ForwardRef$Z } from './svgs/customer-service.svg.js';
import { ReactComponent as ForwardRef$_ } from './svgs/delete.svg.js';
import { ReactComponent as ForwardRef$$ } from './svgs/dentist.svg.js';
import { ReactComponent as ForwardRef$10 } from './svgs/desinfectant.svg.js';
import { ReactComponent as ForwardRef$11 } from './svgs/diners-club.svg.js';
import { ReactComponent as ForwardRef$12 } from './svgs/discount.svg.js';
import { ReactComponent as ForwardRef$13 } from './svgs/diskette.svg.js';
import { ReactComponent as ForwardRef$14 } from './svgs/dna.svg.js';
import { ReactComponent as ForwardRef$15 } from './svgs/doctor.svg.js';
import { ReactComponent as ForwardRef$16 } from './svgs/dollar.svg.js';
import { ReactComponent as ForwardRef$17 } from './svgs/download-file.svg.js';
import { ReactComponent as ForwardRef$18 } from './svgs/download.svg.js';
import { ReactComponent as ForwardRef$19 } from './svgs/drops-1.svg.js';
import { ReactComponent as ForwardRef$1a } from './svgs/drops.svg.js';
import { ReactComponent as ForwardRef$1b } from './svgs/drugs.svg.js';
import { ReactComponent as ForwardRef$1c } from './svgs/ear.svg.js';
import { ReactComponent as ForwardRef$1d } from './svgs/edit.svg.js';
import { ReactComponent as ForwardRef$1e } from './svgs/email-1.svg.js';
import { ReactComponent as ForwardRef$1f } from './svgs/email-2.svg.js';
import { ReactComponent as ForwardRef$1g } from './svgs/email.svg.js';
import { ReactComponent as ForwardRef$1h } from './svgs/emails.svg.js';
import { ReactComponent as ForwardRef$1i } from './svgs/emergency-call.svg.js';
import { ReactComponent as ForwardRef$1j } from './svgs/emergency.svg.js';
import { ReactComponent as ForwardRef$1k } from './svgs/envelope-1.svg.js';
import { ReactComponent as ForwardRef$1l } from './svgs/envelope.svg.js';
import { ReactComponent as ForwardRef$1m } from './svgs/euro.svg.js';
import { ReactComponent as ForwardRef$1n } from './svgs/expand.svg.js';
import { ReactComponent as ForwardRef$1o } from './svgs/eye-1.svg.js';
import { ReactComponent as ForwardRef$1p } from './svgs/eye-2.svg.js';
import { ReactComponent as ForwardRef$1q } from './svgs/eye.svg.js';
import { ReactComponent as ForwardRef$1r } from './svgs/favorites.svg.js';
import { ReactComponent as ForwardRef$1s } from './svgs/file-1.svg.js';
import { ReactComponent as ForwardRef$1t } from './svgs/file.svg.js';
import { ReactComponent as ForwardRef$1u } from './svgs/files-1.svg.js';
import { ReactComponent as ForwardRef$1v } from './svgs/files-2.svg.js';
import { ReactComponent as ForwardRef$1w } from './svgs/files.svg.js';
import { ReactComponent as ForwardRef$1x } from './svgs/first-aid-kit.svg.js';
import { ReactComponent as ForwardRef$1y } from './svgs/flag.svg.js';
import { ReactComponent as ForwardRef$1z } from './svgs/flask-1.svg.js';
import { ReactComponent as ForwardRef$1A } from './svgs/flask-2.svg.js';
import { ReactComponent as ForwardRef$1B } from './svgs/flask.svg.js';
import { ReactComponent as ForwardRef$1C } from './svgs/folder-1.svg.js';
import { ReactComponent as ForwardRef$1D } from './svgs/folder-2.svg.js';
import { ReactComponent as ForwardRef$1E } from './svgs/folder-3.svg.js';
import { ReactComponent as ForwardRef$1F } from './svgs/folder-4.svg.js';
import { ReactComponent as ForwardRef$1G } from './svgs/folder-5.svg.js';
import { ReactComponent as ForwardRef$1H } from './svgs/furniture.svg.js';
import { ReactComponent as ForwardRef$1I } from './svgs/garbage.svg.js';
import { ReactComponent as ForwardRef$1J } from './svgs/gift-card.svg.js';
import { ReactComponent as ForwardRef$1K } from './svgs/gift.svg.js';
import { ReactComponent as ForwardRef$1L } from './svgs/growth.svg.js';
import { ReactComponent as ForwardRef$1M } from './svgs/hamburger.svg.js';
import { ReactComponent as ForwardRef$1N } from './svgs/hanger.svg.js';
import { ReactComponent as ForwardRef$1O } from './svgs/headphones.svg.js';
import { ReactComponent as ForwardRef$1P } from './svgs/headset.svg.js';
import { ReactComponent as ForwardRef$1Q } from './svgs/health-care-1.svg.js';
import { ReactComponent as ForwardRef$1R } from './svgs/health-care.svg.js';
import { ReactComponent as ForwardRef$1S } from './svgs/heart.svg.js';
import { ReactComponent as ForwardRef$1T } from './svgs/helicopter.svg.js';
import { ReactComponent as ForwardRef$1U } from './svgs/hierarchical-structure.svg.js';
import { ReactComponent as ForwardRef$1V } from './svgs/high-heels.svg.js';
import { ReactComponent as ForwardRef$1W } from './svgs/home.svg.js';
import { ReactComponent as ForwardRef$1X } from './svgs/hospital-1.svg.js';
import { ReactComponent as ForwardRef$1Y } from './svgs/hospital-2.svg.js';
import { ReactComponent as ForwardRef$1Z } from './svgs/hospital.svg.js';
import { ReactComponent as ForwardRef$1_ } from './svgs/hourglass.svg.js';
import { ReactComponent as ForwardRef$1$ } from './svgs/idea.svg.js';
import { ReactComponent as ForwardRef$20 } from './svgs/inbox-1.svg.js';
import { ReactComponent as ForwardRef$21 } from './svgs/inbox-11.svg.js';
import { ReactComponent as ForwardRef$22 } from './svgs/inbox.svg.js';
import { ReactComponent as ForwardRef$23 } from './svgs/injection.svg.js';
import { ReactComponent as ForwardRef$24 } from './svgs/key.svg.js';
import { ReactComponent as ForwardRef$25 } from './svgs/kidneys.svg.js';
import { ReactComponent as ForwardRef$26 } from './svgs/left-alignment.svg.js';
import { ReactComponent as ForwardRef$27 } from './svgs/levels.svg.js';
import { ReactComponent as ForwardRef$28 } from './svgs/library.svg.js';
import { ReactComponent as ForwardRef$29 } from './svgs/light-bulb.svg.js';
import { ReactComponent as ForwardRef$2a } from './svgs/link.svg.js';
import { ReactComponent as ForwardRef$2b } from './svgs/list-1.svg.js';
import { ReactComponent as ForwardRef$2c } from './svgs/list.svg.js';
import { ReactComponent as ForwardRef$2d } from './svgs/loading.svg.js';
import { ReactComponent as ForwardRef$2e } from './svgs/loyalty.svg.js';
import { ReactComponent as ForwardRef$2f } from './svgs/lungs.svg.js';
import { ReactComponent as ForwardRef$2g } from './svgs/mail-1.svg.js';
import { ReactComponent as ForwardRef$2h } from './svgs/mail.svg.js';
import { ReactComponent as ForwardRef$2i } from './svgs/map.svg.js';
import { ReactComponent as ForwardRef$2j } from './svgs/mastercard.svg.js';
import { ReactComponent as ForwardRef$2k } from './svgs/maximize.svg.js';
import { ReactComponent as ForwardRef$2l } from './svgs/medal-1.svg.js';
import { ReactComponent as ForwardRef$2m } from './svgs/medal.svg.js';
import { ReactComponent as ForwardRef$2n } from './svgs/medical-result-1.svg.js';
import { ReactComponent as ForwardRef$2o } from './svgs/medical-result.svg.js';
import { ReactComponent as ForwardRef$2p } from './svgs/medicine-1.svg.js';
import { ReactComponent as ForwardRef$2q } from './svgs/medicine-book.svg.js';
import { ReactComponent as ForwardRef$2r } from './svgs/medicine.svg.js';
import { ReactComponent as ForwardRef$2s } from './svgs/megaphone.svg.js';
import { ReactComponent as ForwardRef$2t } from './svgs/message-1.svg.js';
import { ReactComponent as ForwardRef$2u } from './svgs/message.svg.js';
import { ReactComponent as ForwardRef$2v } from './svgs/microphone.svg.js';
import { ReactComponent as ForwardRef$2w } from './svgs/microscope.svg.js';
import { ReactComponent as ForwardRef$2x } from './svgs/minimize.svg.js';
import { ReactComponent as ForwardRef$2y } from './svgs/money-1.svg.js';
import { ReactComponent as ForwardRef$2z } from './svgs/money.svg.js';
import { ReactComponent as ForwardRef$2A } from './svgs/mortar.svg.js';
import { ReactComponent as ForwardRef$2B } from './svgs/mountains.svg.js';
import { ReactComponent as ForwardRef$2C } from './svgs/music.svg.js';
import { ReactComponent as ForwardRef$2D } from './svgs/networking-1.svg.js';
import { ReactComponent as ForwardRef$2E } from './svgs/networking.svg.js';
import { ReactComponent as ForwardRef$2F } from './svgs/next-1.svg.js';
import { ReactComponent as ForwardRef$2G } from './svgs/next.svg.js';
import { ReactComponent as ForwardRef$2H } from './svgs/notepad.svg.js';
import { ReactComponent as ForwardRef$2I } from './svgs/notification.svg.js';
import { ReactComponent as ForwardRef$2J } from './svgs/nurse-1.svg.js';
import { ReactComponent as ForwardRef$2K } from './svgs/nurse.svg.js';
import { ReactComponent as ForwardRef$2L } from './svgs/open-1.svg.js';
import { ReactComponent as ForwardRef$2M } from './svgs/open-book-1.svg.js';
import { ReactComponent as ForwardRef$2N } from './svgs/open-book.svg.js';
import { ReactComponent as ForwardRef$2O } from './svgs/open.svg.js';
import { ReactComponent as ForwardRef$2P } from './svgs/organization.svg.js';
import { ReactComponent as ForwardRef$2Q } from './svgs/outbox-1.svg.js';
import { ReactComponent as ForwardRef$2R } from './svgs/outbox.svg.js';
import { ReactComponent as ForwardRef$2S } from './svgs/package-1.svg.js';
import { ReactComponent as ForwardRef$2T } from './svgs/package.svg.js';
import { ReactComponent as ForwardRef$2U } from './svgs/padlock.svg.js';
import { ReactComponent as ForwardRef$2V } from './svgs/paid.svg.js';
import { ReactComponent as ForwardRef$2W } from './svgs/panel.svg.js';
import { ReactComponent as ForwardRef$2X } from './svgs/paper-plane.svg.js';
import { ReactComponent as ForwardRef$2Y } from './svgs/password-1.svg.js';
import { ReactComponent as ForwardRef$2Z } from './svgs/password.svg.js';
import { ReactComponent as ForwardRef$55 } from './svgs/pattern.svg.js';
import { ReactComponent as ForwardRef$2_ } from './svgs/pawn.svg.js';
import { ReactComponent as ForwardRef$2$ } from './svgs/percentage.svg.js';
import { ReactComponent as ForwardRef$30 } from './svgs/pharmacy.svg.js';
import { ReactComponent as ForwardRef$31 } from './svgs/photo-camera.svg.js';
import { ReactComponent as ForwardRef$32 } from './svgs/piano.svg.js';
import { ReactComponent as ForwardRef$33 } from './svgs/picture-1.svg.js';
import { ReactComponent as ForwardRef$34 } from './svgs/picture.svg.js';
import { ReactComponent as ForwardRef$35 } from './svgs/piggy-bank.svg.js';
import { ReactComponent as ForwardRef$36 } from './svgs/pill-1.svg.js';
import { ReactComponent as ForwardRef$37 } from './svgs/pill.svg.js';
import { ReactComponent as ForwardRef$38 } from './svgs/pills-1.svg.js';
import { ReactComponent as ForwardRef$39 } from './svgs/pills-2.svg.js';
import { ReactComponent as ForwardRef$3a } from './svgs/pills-3.svg.js';
import { ReactComponent as ForwardRef$3b } from './svgs/pills.svg.js';
import { ReactComponent as ForwardRef$3c } from './svgs/pipette.svg.js';
import { ReactComponent as ForwardRef$3d } from './svgs/placeholder-1.svg.js';
import { ReactComponent as ForwardRef$3e } from './svgs/placeholder.svg.js';
import { ReactComponent as ForwardRef$3f } from './svgs/plan.svg.js';
import { ReactComponent as ForwardRef$3g } from './svgs/plaster.svg.js';
import { ReactComponent as ForwardRef$3h } from './svgs/pound-sterling.svg.js';
import { ReactComponent as ForwardRef$3i } from './svgs/power-button.svg.js';
import { ReactComponent as ForwardRef$3j } from './svgs/premium.svg.js';
import { ReactComponent as ForwardRef$3k } from './svgs/previous.svg.js';
import { ReactComponent as ForwardRef$3l } from './svgs/price-tag-1.svg.js';
import { ReactComponent as ForwardRef$3m } from './svgs/price-tag.svg.js';
import { ReactComponent as ForwardRef$3n } from './svgs/print.svg.js';
import { ReactComponent as ForwardRef$3o } from './svgs/pulse.svg.js';
import { ReactComponent as ForwardRef$3p } from './svgs/push-pin.svg.js';
import { ReactComponent as ForwardRef$3q } from './svgs/puzzle-1.svg.js';
import { ReactComponent as ForwardRef$3r } from './svgs/puzzle.svg.js';
import { ReactComponent as ForwardRef$3s } from './svgs/rain.svg.js';
import { ReactComponent as ForwardRef$3t } from './svgs/ranking.svg.js';
import { ReactComponent as ForwardRef$3u } from './svgs/remove.svg.js';
import { ReactComponent as ForwardRef$3v } from './svgs/repeat.svg.js';
import { ReactComponent as ForwardRef$3w } from './svgs/reply-1.svg.js';
import { ReactComponent as ForwardRef$3x } from './svgs/reply.svg.js';
import { ReactComponent as ForwardRef$3y } from './svgs/ribbon.svg.js';
import { ReactComponent as ForwardRef$3z } from './svgs/right-alignment.svg.js';
import { ReactComponent as ForwardRef$3A } from './svgs/route.svg.js';
import { ReactComponent as ForwardRef$3B } from './svgs/sale.svg.js';
import { ReactComponent as ForwardRef$3C } from './svgs/savings.svg.js';
import { ReactComponent as ForwardRef$3D } from './svgs/scale.svg.js';
import { ReactComponent as ForwardRef$3E } from './svgs/scroll.svg.js';
import { ReactComponent as ForwardRef$3F } from './svgs/search-1.svg.js';
import { ReactComponent as ForwardRef$3G } from './svgs/search-11.svg.js';
import { ReactComponent as ForwardRef$3H } from './svgs/search.svg.js';
import { ReactComponent as ForwardRef$3I } from './svgs/server.svg.js';
import { ReactComponent as ForwardRef$3J } from './svgs/settings-1.svg.js';
import { ReactComponent as ForwardRef$3K } from './svgs/settings-11.svg.js';
import { ReactComponent as ForwardRef$3L } from './svgs/settings.svg.js';
import { ReactComponent as ForwardRef$3M } from './svgs/shield-1.svg.js';
import { ReactComponent as ForwardRef$3N } from './svgs/shield-11.svg.js';
import { ReactComponent as ForwardRef$3O } from './svgs/shield.svg.js';
import { ReactComponent as ForwardRef$3P } from './svgs/shirt.svg.js';
import { ReactComponent as ForwardRef$3Q } from './svgs/shopping-bag.svg.js';
import { ReactComponent as ForwardRef$3R } from './svgs/shopping-basket-1.svg.js';
import { ReactComponent as ForwardRef$3S } from './svgs/shopping-basket-2.svg.js';
import { ReactComponent as ForwardRef$3T } from './svgs/shopping-basket.svg.js';
import { ReactComponent as ForwardRef$3U } from './svgs/shopping-cart-1.svg.js';
import { ReactComponent as ForwardRef$3W } from './svgs/shopping-cart-2.svg.js';
import { ReactComponent as ForwardRef$3X } from './svgs/shopping-cart-3.svg.js';
import { ReactComponent as ForwardRef$3Y } from './svgs/shopping-cart-4.svg.js';
import { ReactComponent as ForwardRef$3Z } from './svgs/shopping-cart-5.svg.js';
import { ReactComponent as ForwardRef$3_ } from './svgs/shopping-cart-6.svg.js';
import { ReactComponent as ForwardRef$3$ } from './svgs/shopping-cart-7.svg.js';
import { ReactComponent as ForwardRef$40 } from './svgs/shopping-cart-8.svg.js';
import { ReactComponent as ForwardRef$3V } from './svgs/shopping-cart-11.svg.js';
import { ReactComponent as ForwardRef$41 } from './svgs/shopping-cart.svg.js';
import { ReactComponent as ForwardRef$42 } from './svgs/shuffle.svg.js';
import { ReactComponent as ForwardRef$43 } from './svgs/smartphone.svg.js';
import { ReactComponent as ForwardRef$44 } from './svgs/soap.svg.js';
import { ReactComponent as ForwardRef$45 } from './svgs/sound-1.svg.js';
import { ReactComponent as ForwardRef$46 } from './svgs/sound.svg.js';
import { ReactComponent as ForwardRef$47 } from './svgs/speech-bubble.svg.js';
import { ReactComponent as ForwardRef$48 } from './svgs/speedometer.svg.js';
import { ReactComponent as ForwardRef$49 } from './svgs/startup.svg.js';
import { ReactComponent as ForwardRef$4a } from './svgs/statistics.svg.js';
import { ReactComponent as ForwardRef$4b } from './svgs/stethoscope-1.svg.js';
import { ReactComponent as ForwardRef$4c } from './svgs/stethoscope.svg.js';
import { ReactComponent as ForwardRef$4d } from './svgs/sticker.svg.js';
import { ReactComponent as ForwardRef$4e } from './svgs/store-1.svg.js';
import { ReactComponent as ForwardRef$4f } from './svgs/store.svg.js';
import { ReactComponent as ForwardRef$4g } from './svgs/stretcher-1.svg.js';
import { ReactComponent as ForwardRef$4h } from './svgs/stretcher.svg.js';
import { ReactComponent as ForwardRef$4i } from './svgs/surgeon.svg.js';
import { ReactComponent as ForwardRef$4j } from './svgs/survey.svg.js';
import { ReactComponent as ForwardRef$4k } from './svgs/switch.svg.js';
import { ReactComponent as ForwardRef$4l } from './svgs/symbol.svg.js';
import { ReactComponent as ForwardRef$4m } from './svgs/syringe.svg.js';
import { ReactComponent as ForwardRef$4n } from './svgs/tag.svg.js';
import { ReactComponent as ForwardRef$4o } from './svgs/target-1.svg.js';
import { ReactComponent as ForwardRef$4p } from './svgs/target-11.svg.js';
import { ReactComponent as ForwardRef$4q } from './svgs/target.svg.js';
import { ReactComponent as ForwardRef$4r } from './svgs/telephone.svg.js';
import { ReactComponent as ForwardRef$4s } from './svgs/test-tube-1.svg.js';
import { ReactComponent as ForwardRef$4t } from './svgs/test-tube.svg.js';
import { ReactComponent as ForwardRef$4u } from './svgs/test.svg.js';
import { ReactComponent as ForwardRef$4v } from './svgs/thermometer-1.svg.js';
import { ReactComponent as ForwardRef$4w } from './svgs/thermometer.svg.js';
import { ReactComponent as ForwardRef$4x } from './svgs/ticket.svg.js';
import { ReactComponent as ForwardRef$4y } from './svgs/time-1.svg.js';
import { ReactComponent as ForwardRef$4A } from './svgs/time-2.svg.js';
import { ReactComponent as ForwardRef$4z } from './svgs/time-11.svg.js';
import { ReactComponent as ForwardRef$4B } from './svgs/time.svg.js';
import { ReactComponent as ForwardRef$4C } from './svgs/timer.svg.js';
import { ReactComponent as ForwardRef$4D } from './svgs/tooth.svg.js';
import { ReactComponent as ForwardRef$4E } from './svgs/transfusion-1.svg.js';
import { ReactComponent as ForwardRef$4F } from './svgs/transfusion.svg.js';
import { ReactComponent as ForwardRef$4G } from './svgs/truck-1.svg.js';
import { ReactComponent as ForwardRef$4H } from './svgs/truck-2.svg.js';
import { ReactComponent as ForwardRef$4I } from './svgs/truck.svg.js';
import { ReactComponent as ForwardRef$4J } from './svgs/typewriter.svg.js';
import { ReactComponent as ForwardRef$4K } from './svgs/uniform.svg.js';
import { ReactComponent as ForwardRef$4L } from './svgs/unlock.svg.js';
import { ReactComponent as ForwardRef$4M } from './svgs/usb.svg.js';
import { ReactComponent as ForwardRef$4N } from './svgs/user-1.svg.js';
import { ReactComponent as ForwardRef$4O } from './svgs/user-11.svg.js';
import { ReactComponent as ForwardRef$4P } from './svgs/user.svg.js';
import { ReactComponent as ForwardRef$4Q } from './svgs/victory.svg.js';
import { ReactComponent as ForwardRef$4R } from './svgs/video-camera.svg.js';
import { ReactComponent as ForwardRef$4S } from './svgs/video-player.svg.js';
import { ReactComponent as ForwardRef$4T } from './svgs/visa.svg.js';
import { ReactComponent as ForwardRef$4U } from './svgs/visualization-1.svg.js';
import { ReactComponent as ForwardRef$4V } from './svgs/visualization.svg.js';
import { ReactComponent as ForwardRef$4W } from './svgs/watch.svg.js';
import { ReactComponent as ForwardRef$4X } from './svgs/weighing-scale.svg.js';
import { ReactComponent as ForwardRef$4Y } from './svgs/wheelchair-1.svg.js';
import { ReactComponent as ForwardRef$4Z } from './svgs/wheelchair.svg.js';
import { ReactComponent as ForwardRef$4_ } from './svgs/wifi.svg.js';
import { ReactComponent as ForwardRef$4$ } from './svgs/wristwatch.svg.js';
import { ReactComponent as ForwardRef$50 } from './svgs/writing-1.svg.js';
import { ReactComponent as ForwardRef$51 } from './svgs/writing-2.svg.js';
import { ReactComponent as ForwardRef$52 } from './svgs/writing.svg.js';
import { ReactComponent as ForwardRef$53 } from './svgs/x-ray.svg.js';
import { ReactComponent as ForwardRef$54 } from './svgs/yen.svg.js';

const AddIllustrative = ForwardRef;
const AgendaIllustrative = ForwardRef$1;
const AlcoholIllustrative = ForwardRef$2;
const AmbulanceIllustrative = ForwardRef$3;
const AmericanexpressIllustrative = ForwardRef$4;
const AmpoulIllustrative = ForwardRef$5;
const AnalyticsIllustrative = ForwardRef$6;
const AppshopIllustrative = ForwardRef$7;
const AppleIllustrative = ForwardRef$8;
const AppreciationIllustrative = ForwardRef$9;
const AsteriskIllustrative = ForwardRef$a;
const Badge1Illustrative = ForwardRef$b;
const BadgeIllustrative = ForwardRef$c;
const BandaidIllustrative = ForwardRef$d;
const BandageIllustrative = ForwardRef$e;
const BarcodeIllustrative = ForwardRef$f;
const BatteryIllustrative = ForwardRef$g;
const BedIllustrative = ForwardRef$h;
const BlockIllustrative = ForwardRef$i;
const BloodtestIllustrative = ForwardRef$j;
const BoneIllustrative = ForwardRef$k;
const BookmarkIllustrative = ForwardRef$l;
const Box1Illustrative = ForwardRef$m;
const BoxIllustrative = ForwardRef$n;
const Brightness1Illustrative = ForwardRef$o;
const BrightnessIllustrative = ForwardRef$p;
const Browser1Illustrative = ForwardRef$q;
const Browser11Illustrative = ForwardRef$r;
const BrowserIllustrative = ForwardRef$s;
const CalculatorIllustrative = ForwardRef$t;
const Calendar1Illustrative = ForwardRef$u;
const CalendarIllustrative = ForwardRef$v;
const CancelIllustrative = ForwardRef$w;
const CartIllustrative = ForwardRef$x;
const CellsIllustrative = ForwardRef$y;
const Chat1Illustrative = ForwardRef$z;
const Chat2Illustrative = ForwardRef$A;
const Chat3Illustrative = ForwardRef$B;
const Chat5Illustrative = ForwardRef$C;
const Chat6Illustrative = ForwardRef$D;
const Chat7Illustrative = ForwardRef$E;
const Chat4Illustrative = ForwardRef$F;
const CheckedIllustrative = ForwardRef$G;
const ClockIllustrative = ForwardRef$H;
const ClosedIllustrative = ForwardRef$I;
const CloudcomputingIllustrative = ForwardRef$J;
const CoffeecupIllustrative = ForwardRef$K;
const CoinsIllustrative = ForwardRef$L;
const CompactdiscIllustrative = ForwardRef$M;
const CompassIllustrative = ForwardRef$N;
const ComputerIllustrative = ForwardRef$O;
const Conversation1Illustrative = ForwardRef$P;
const Conversation2Illustrative = ForwardRef$Q;
const ConversationIllustrative = ForwardRef$R;
const Creditcard1Illustrative = ForwardRef$S;
const Creditcard2Illustrative = ForwardRef$T;
const Creditcard3Illustrative = ForwardRef$U;
const Creditcard4Illustrative = ForwardRef$V;
const Creditcard5Illustrative = ForwardRef$W;
const CreditcardIllustrative = ForwardRef$X;
const CupIllustrative = ForwardRef$Y;
const CustomerserviceIllustrative = ForwardRef$Z;
const DeleteIllustrative = ForwardRef$_;
const DentistIllustrative = ForwardRef$$;
const DesinfectantIllustrative = ForwardRef$10;
const DinersclubIllustrative = ForwardRef$11;
const DiscountIllustrative = ForwardRef$12;
const DisketteIllustrative = ForwardRef$13;
const DnaIllustrative = ForwardRef$14;
const DoctorIllustrative = ForwardRef$15;
const DollarIllustrative = ForwardRef$16;
const DownloadfileIllustrative = ForwardRef$17;
const DownloadIllustrative = ForwardRef$18;
const Drops1Illustrative = ForwardRef$19;
const DropsIllustrative = ForwardRef$1a;
const DrugsIllustrative = ForwardRef$1b;
const EarIllustrative = ForwardRef$1c;
const EditIllustrative = ForwardRef$1d;
const Email1Illustrative = ForwardRef$1e;
const Email2Illustrative = ForwardRef$1f;
const EmailIllustrative = ForwardRef$1g;
const EmailsIllustrative = ForwardRef$1h;
const EmergencycallIllustrative = ForwardRef$1i;
const EmergencyIllustrative = ForwardRef$1j;
const Envelope1Illustrative = ForwardRef$1k;
const EnvelopeIllustrative = ForwardRef$1l;
const EuroIllustrative = ForwardRef$1m;
const ExpandIllustrative = ForwardRef$1n;
const Eye1Illustrative = ForwardRef$1o;
const Eye2Illustrative = ForwardRef$1p;
const EyeIllustrative = ForwardRef$1q;
const FavoritesIllustrative = ForwardRef$1r;
const File1Illustrative = ForwardRef$1s;
const FileIllustrative = ForwardRef$1t;
const Files1Illustrative = ForwardRef$1u;
const Files2Illustrative = ForwardRef$1v;
const FilesIllustrative = ForwardRef$1w;
const FirstaidkitIllustrative = ForwardRef$1x;
const FlagIllustrative = ForwardRef$1y;
const Flask1Illustrative = ForwardRef$1z;
const Flask2Illustrative = ForwardRef$1A;
const FlaskIllustrative = ForwardRef$1B;
const Folder1Illustrative = ForwardRef$1C;
const Folder2Illustrative = ForwardRef$1D;
const Folder3Illustrative = ForwardRef$1E;
const Folder4Illustrative = ForwardRef$1F;
const Folder5Illustrative = ForwardRef$1G;
const FurnitureIllustrative = ForwardRef$1H;
const GarbageIllustrative = ForwardRef$1I;
const GiftcardIllustrative = ForwardRef$1J;
const GiftIllustrative = ForwardRef$1K;
const GrowthIllustrative = ForwardRef$1L;
const HamburgerIllustrative = ForwardRef$1M;
const HangerIllustrative = ForwardRef$1N;
const HeadphonesIllustrative = ForwardRef$1O;
const HeadsetIllustrative = ForwardRef$1P;
const Healthcare1Illustrative = ForwardRef$1Q;
const HealthcareIllustrative = ForwardRef$1R;
const HeartIllustrative = ForwardRef$1S;
const HelicopterIllustrative = ForwardRef$1T;
const HierarchicalstructureIllustrative = ForwardRef$1U;
const HighheelsIllustrative = ForwardRef$1V;
const HomeIllustrative = ForwardRef$1W;
const Hospital1Illustrative = ForwardRef$1X;
const Hospital2Illustrative = ForwardRef$1Y;
const HospitalIllustrative = ForwardRef$1Z;
const HourglassIllustrative = ForwardRef$1_;
const IdeaIllustrative = ForwardRef$1$;
const Inbox1Illustrative = ForwardRef$20;
const Inbox11Illustrative = ForwardRef$21;
const InboxIllustrative = ForwardRef$22;
const InjectionIllustrative = ForwardRef$23;
const KeyIllustrative = ForwardRef$24;
const KidneysIllustrative = ForwardRef$25;
const LeftalignmentIllustrative = ForwardRef$26;
const LevelsIllustrative = ForwardRef$27;
const LibraryIllustrative = ForwardRef$28;
const LightbulbIllustrative = ForwardRef$29;
const LinkIllustrative = ForwardRef$2a;
const List1Illustrative = ForwardRef$2b;
const ListIllustrative = ForwardRef$2c;
const LoadingIllustrative = ForwardRef$2d;
const LoyaltyIllustrative = ForwardRef$2e;
const LungsIllustrative = ForwardRef$2f;
const Mail1Illustrative = ForwardRef$2g;
const MailIllustrative = ForwardRef$2h;
const MapIllustrative = ForwardRef$2i;
const MastercardIllustrative = ForwardRef$2j;
const MaximizeIllustrative = ForwardRef$2k;
const Medal1Illustrative = ForwardRef$2l;
const MedalIllustrative = ForwardRef$2m;
const Medicalresult1Illustrative = ForwardRef$2n;
const MedicalresultIllustrative = ForwardRef$2o;
const Medicine1Illustrative = ForwardRef$2p;
const MedicinebookIllustrative = ForwardRef$2q;
const MedicineIllustrative = ForwardRef$2r;
const MegaphoneIllustrative = ForwardRef$2s;
const Message1Illustrative = ForwardRef$2t;
const MessageIllustrative = ForwardRef$2u;
const MicrophoneIllustrative = ForwardRef$2v;
const MicroscopeIllustrative = ForwardRef$2w;
const MinimizeIllustrative = ForwardRef$2x;
const Money1Illustrative = ForwardRef$2y;
const MoneyIllustrative = ForwardRef$2z;
const MortarIllustrative = ForwardRef$2A;
const MountainsIllustrative = ForwardRef$2B;
const MusicIllustrative = ForwardRef$2C;
const Networking1Illustrative = ForwardRef$2D;
const NetworkingIllustrative = ForwardRef$2E;
const Next1Illustrative = ForwardRef$2F;
const NextIllustrative = ForwardRef$2G;
const NotepadIllustrative = ForwardRef$2H;
const NotificationIllustrative = ForwardRef$2I;
const Nurse1Illustrative = ForwardRef$2J;
const NurseIllustrative = ForwardRef$2K;
const Open1Illustrative = ForwardRef$2L;
const Openbook1Illustrative = ForwardRef$2M;
const OpenbookIllustrative = ForwardRef$2N;
const OpenIllustrative = ForwardRef$2O;
const OrganizationIllustrative = ForwardRef$2P;
const Outbox1Illustrative = ForwardRef$2Q;
const OutboxIllustrative = ForwardRef$2R;
const Package1Illustrative = ForwardRef$2S;
const PackageIllustrative = ForwardRef$2T;
const PadlockIllustrative = ForwardRef$2U;
const PaidIllustrative = ForwardRef$2V;
const PanelIllustrative = ForwardRef$2W;
const PaperplaneIllustrative = ForwardRef$2X;
const Password1Illustrative = ForwardRef$2Y;
const PasswordIllustrative = ForwardRef$2Z;
const PawnIllustrative = ForwardRef$2_;
const PercentageIllustrative = ForwardRef$2$;
const PharmacyIllustrative = ForwardRef$30;
const PhotocameraIllustrative = ForwardRef$31;
const PianoIllustrative = ForwardRef$32;
const Picture1Illustrative = ForwardRef$33;
const PictureIllustrative = ForwardRef$34;
const PiggybankIllustrative = ForwardRef$35;
const Pill1Illustrative = ForwardRef$36;
const PillIllustrative = ForwardRef$37;
const Pills1Illustrative = ForwardRef$38;
const Pills2Illustrative = ForwardRef$39;
const Pills3Illustrative = ForwardRef$3a;
const PillsIllustrative = ForwardRef$3b;
const PipetteIllustrative = ForwardRef$3c;
const Placeholder1Illustrative = ForwardRef$3d;
const PlaceholderIllustrative = ForwardRef$3e;
const PlanIllustrative = ForwardRef$3f;
const PlasterIllustrative = ForwardRef$3g;
const PoundsterlingIllustrative = ForwardRef$3h;
const PowerbuttonIllustrative = ForwardRef$3i;
const PremiumIllustrative = ForwardRef$3j;
const PreviousIllustrative = ForwardRef$3k;
const Pricetag1Illustrative = ForwardRef$3l;
const PricetagIllustrative = ForwardRef$3m;
const PrintIllustrative = ForwardRef$3n;
const PulseIllustrative = ForwardRef$3o;
const PushpinIllustrative = ForwardRef$3p;
const Puzzle1Illustrative = ForwardRef$3q;
const PuzzleIllustrative = ForwardRef$3r;
const RainIllustrative = ForwardRef$3s;
const RankingIllustrative = ForwardRef$3t;
const RemoveIllustrative = ForwardRef$3u;
const RepeatIllustrative = ForwardRef$3v;
const Reply1Illustrative = ForwardRef$3w;
const ReplyIllustrative = ForwardRef$3x;
const RibbonIllustrative = ForwardRef$3y;
const RightalignmentIllustrative = ForwardRef$3z;
const RouteIllustrative = ForwardRef$3A;
const SaleIllustrative = ForwardRef$3B;
const SavingsIllustrative = ForwardRef$3C;
const ScaleIllustrative = ForwardRef$3D;
const ScrollIllustrative = ForwardRef$3E;
const Search1Illustrative = ForwardRef$3F;
const Search11Illustrative = ForwardRef$3G;
const SearchIllustrative = ForwardRef$3H;
const ServerIllustrative = ForwardRef$3I;
const Settings1Illustrative = ForwardRef$3J;
const Settings11Illustrative = ForwardRef$3K;
const SettingsIllustrative = ForwardRef$3L;
const Shield1Illustrative = ForwardRef$3M;
const Shield11Illustrative = ForwardRef$3N;
const ShieldIllustrative = ForwardRef$3O;
const ShirtIllustrative = ForwardRef$3P;
const ShoppingbagIllustrative = ForwardRef$3Q;
const Shoppingbasket1Illustrative = ForwardRef$3R;
const Shoppingbasket2Illustrative = ForwardRef$3S;
const ShoppingbasketIllustrative = ForwardRef$3T;
const Shoppingcart1Illustrative = ForwardRef$3U;
const Shoppingcart11Illustrative = ForwardRef$3V;
const Shoppingcart2Illustrative = ForwardRef$3W;
const Shoppingcart3Illustrative = ForwardRef$3X;
const Shoppingcart4Illustrative = ForwardRef$3Y;
const Shoppingcart5Illustrative = ForwardRef$3Z;
const Shoppingcart6Illustrative = ForwardRef$3_;
const Shoppingcart7Illustrative = ForwardRef$3$;
const Shoppingcart8Illustrative = ForwardRef$40;
const ShoppingcartIllustrative = ForwardRef$41;
const ShuffleIllustrative = ForwardRef$42;
const SmartphoneIllustrative = ForwardRef$43;
const SoapIllustrative = ForwardRef$44;
const Sound1Illustrative = ForwardRef$45;
const SoundIllustrative = ForwardRef$46;
const SpeechbubbleIllustrative = ForwardRef$47;
const SpeedometerIllustrative = ForwardRef$48;
const StartupIllustrative = ForwardRef$49;
const StatisticsIllustrative = ForwardRef$4a;
const Stethoscope1Illustrative = ForwardRef$4b;
const StethoscopeIllustrative = ForwardRef$4c;
const StickerIllustrative = ForwardRef$4d;
const Store1Illustrative = ForwardRef$4e;
const StoreIllustrative = ForwardRef$4f;
const Stretcher1Illustrative = ForwardRef$4g;
const StretcherIllustrative = ForwardRef$4h;
const SurgeonIllustrative = ForwardRef$4i;
const SurveyIllustrative = ForwardRef$4j;
const SwitchIllustrative = ForwardRef$4k;
const SymbolIllustrative = ForwardRef$4l;
const SyringeIllustrative = ForwardRef$4m;
const TagIllustrative = ForwardRef$4n;
const Target1Illustrative = ForwardRef$4o;
const Target11Illustrative = ForwardRef$4p;
const TargetIllustrative = ForwardRef$4q;
const TelephoneIllustrative = ForwardRef$4r;
const Testtube1Illustrative = ForwardRef$4s;
const TesttubeIllustrative = ForwardRef$4t;
const TestIllustrative = ForwardRef$4u;
const Thermometer1Illustrative = ForwardRef$4v;
const ThermometerIllustrative = ForwardRef$4w;
const TicketIllustrative = ForwardRef$4x;
const Time1Illustrative = ForwardRef$4y;
const Time11Illustrative = ForwardRef$4z;
const Time2Illustrative = ForwardRef$4A;
const TimeIllustrative = ForwardRef$4B;
const TimerIllustrative = ForwardRef$4C;
const ToothIllustrative = ForwardRef$4D;
const Transfusion1Illustrative = ForwardRef$4E;
const TransfusionIllustrative = ForwardRef$4F;
const Truck1Illustrative = ForwardRef$4G;
const Truck2Illustrative = ForwardRef$4H;
const TruckIllustrative = ForwardRef$4I;
const TypewriterIllustrative = ForwardRef$4J;
const UniformIllustrative = ForwardRef$4K;
const UnlockIllustrative = ForwardRef$4L;
const UsbIllustrative = ForwardRef$4M;
const User1Illustrative = ForwardRef$4N;
const User11Illustrative = ForwardRef$4O;
const UserIllustrative = ForwardRef$4P;
const VictoryIllustrative = ForwardRef$4Q;
const VideocameraIllustrative = ForwardRef$4R;
const VideoplayerIllustrative = ForwardRef$4S;
const VisaIllustrative = ForwardRef$4T;
const Visualization1Illustrative = ForwardRef$4U;
const VisualizationIllustrative = ForwardRef$4V;
const WatchIllustrative = ForwardRef$4W;
const WeighingscaleIllustrative = ForwardRef$4X;
const Wheelchair1Illustrative = ForwardRef$4Y;
const WheelchairIllustrative = ForwardRef$4Z;
const WifiIllustrative = ForwardRef$4_;
const WristwatchIllustrative = ForwardRef$4$;
const Writing1Illustrative = ForwardRef$50;
const Writing2Illustrative = ForwardRef$51;
const WritingIllustrative = ForwardRef$52;
const XrayIllustrative = ForwardRef$53;
const YenIllustrative = ForwardRef$54;
const PatternIllustrative = ForwardRef$55;

export { AddIllustrative, AgendaIllustrative, AlcoholIllustrative, AmbulanceIllustrative, AmericanexpressIllustrative, AmpoulIllustrative, AnalyticsIllustrative, AppleIllustrative, AppreciationIllustrative, AppshopIllustrative, AsteriskIllustrative, Badge1Illustrative, BadgeIllustrative, BandageIllustrative, BandaidIllustrative, BarcodeIllustrative, BatteryIllustrative, BedIllustrative, BlockIllustrative, BloodtestIllustrative, BoneIllustrative, BookmarkIllustrative, Box1Illustrative, BoxIllustrative, Brightness1Illustrative, BrightnessIllustrative, Browser11Illustrative, Browser1Illustrative, BrowserIllustrative, CalculatorIllustrative, Calendar1Illustrative, CalendarIllustrative, CancelIllustrative, CartIllustrative, CellsIllustrative, Chat1Illustrative, Chat2Illustrative, Chat3Illustrative, Chat4Illustrative, Chat5Illustrative, Chat6Illustrative, Chat7Illustrative, CheckedIllustrative, ClockIllustrative, ClosedIllustrative, CloudcomputingIllustrative, CoffeecupIllustrative, CoinsIllustrative, CompactdiscIllustrative, CompassIllustrative, ComputerIllustrative, Conversation1Illustrative, Conversation2Illustrative, ConversationIllustrative, Creditcard1Illustrative, Creditcard2Illustrative, Creditcard3Illustrative, Creditcard4Illustrative, Creditcard5Illustrative, CreditcardIllustrative, CupIllustrative, CustomerserviceIllustrative, DeleteIllustrative, DentistIllustrative, DesinfectantIllustrative, DinersclubIllustrative, DiscountIllustrative, DisketteIllustrative, DnaIllustrative, DoctorIllustrative, DollarIllustrative, DownloadIllustrative, DownloadfileIllustrative, Drops1Illustrative, DropsIllustrative, DrugsIllustrative, EarIllustrative, EditIllustrative, Email1Illustrative, Email2Illustrative, EmailIllustrative, EmailsIllustrative, EmergencyIllustrative, EmergencycallIllustrative, Envelope1Illustrative, EnvelopeIllustrative, EuroIllustrative, ExpandIllustrative, Eye1Illustrative, Eye2Illustrative, EyeIllustrative, FavoritesIllustrative, File1Illustrative, FileIllustrative, Files1Illustrative, Files2Illustrative, FilesIllustrative, FirstaidkitIllustrative, FlagIllustrative, Flask1Illustrative, Flask2Illustrative, FlaskIllustrative, Folder1Illustrative, Folder2Illustrative, Folder3Illustrative, Folder4Illustrative, Folder5Illustrative, FurnitureIllustrative, GarbageIllustrative, GiftIllustrative, GiftcardIllustrative, GrowthIllustrative, HamburgerIllustrative, HangerIllustrative, HeadphonesIllustrative, HeadsetIllustrative, Healthcare1Illustrative, HealthcareIllustrative, HeartIllustrative, HelicopterIllustrative, HierarchicalstructureIllustrative, HighheelsIllustrative, HomeIllustrative, Hospital1Illustrative, Hospital2Illustrative, HospitalIllustrative, HourglassIllustrative, IdeaIllustrative, Inbox11Illustrative, Inbox1Illustrative, InboxIllustrative, InjectionIllustrative, KeyIllustrative, KidneysIllustrative, LeftalignmentIllustrative, LevelsIllustrative, LibraryIllustrative, LightbulbIllustrative, LinkIllustrative, List1Illustrative, ListIllustrative, LoadingIllustrative, LoyaltyIllustrative, LungsIllustrative, Mail1Illustrative, MailIllustrative, MapIllustrative, MastercardIllustrative, MaximizeIllustrative, Medal1Illustrative, MedalIllustrative, Medicalresult1Illustrative, MedicalresultIllustrative, Medicine1Illustrative, MedicineIllustrative, MedicinebookIllustrative, MegaphoneIllustrative, Message1Illustrative, MessageIllustrative, MicrophoneIllustrative, MicroscopeIllustrative, MinimizeIllustrative, Money1Illustrative, MoneyIllustrative, MortarIllustrative, MountainsIllustrative, MusicIllustrative, Networking1Illustrative, NetworkingIllustrative, Next1Illustrative, NextIllustrative, NotepadIllustrative, NotificationIllustrative, Nurse1Illustrative, NurseIllustrative, Open1Illustrative, OpenIllustrative, Openbook1Illustrative, OpenbookIllustrative, OrganizationIllustrative, Outbox1Illustrative, OutboxIllustrative, Package1Illustrative, PackageIllustrative, PadlockIllustrative, PaidIllustrative, PanelIllustrative, PaperplaneIllustrative, Password1Illustrative, PasswordIllustrative, PatternIllustrative, PawnIllustrative, PercentageIllustrative, PharmacyIllustrative, PhotocameraIllustrative, PianoIllustrative, Picture1Illustrative, PictureIllustrative, PiggybankIllustrative, Pill1Illustrative, PillIllustrative, Pills1Illustrative, Pills2Illustrative, Pills3Illustrative, PillsIllustrative, PipetteIllustrative, Placeholder1Illustrative, PlaceholderIllustrative, PlanIllustrative, PlasterIllustrative, PoundsterlingIllustrative, PowerbuttonIllustrative, PremiumIllustrative, PreviousIllustrative, Pricetag1Illustrative, PricetagIllustrative, PrintIllustrative, PulseIllustrative, PushpinIllustrative, Puzzle1Illustrative, PuzzleIllustrative, RainIllustrative, RankingIllustrative, RemoveIllustrative, RepeatIllustrative, Reply1Illustrative, ReplyIllustrative, RibbonIllustrative, RightalignmentIllustrative, RouteIllustrative, SaleIllustrative, SavingsIllustrative, ScaleIllustrative, ScrollIllustrative, Search11Illustrative, Search1Illustrative, SearchIllustrative, ServerIllustrative, Settings11Illustrative, Settings1Illustrative, SettingsIllustrative, Shield11Illustrative, Shield1Illustrative, ShieldIllustrative, ShirtIllustrative, ShoppingbagIllustrative, Shoppingbasket1Illustrative, Shoppingbasket2Illustrative, ShoppingbasketIllustrative, Shoppingcart11Illustrative, Shoppingcart1Illustrative, Shoppingcart2Illustrative, Shoppingcart3Illustrative, Shoppingcart4Illustrative, Shoppingcart5Illustrative, Shoppingcart6Illustrative, Shoppingcart7Illustrative, Shoppingcart8Illustrative, ShoppingcartIllustrative, ShuffleIllustrative, SmartphoneIllustrative, SoapIllustrative, Sound1Illustrative, SoundIllustrative, SpeechbubbleIllustrative, SpeedometerIllustrative, StartupIllustrative, StatisticsIllustrative, Stethoscope1Illustrative, StethoscopeIllustrative, StickerIllustrative, Store1Illustrative, StoreIllustrative, Stretcher1Illustrative, StretcherIllustrative, SurgeonIllustrative, SurveyIllustrative, SwitchIllustrative, SymbolIllustrative, SyringeIllustrative, TagIllustrative, Target11Illustrative, Target1Illustrative, TargetIllustrative, TelephoneIllustrative, TestIllustrative, Testtube1Illustrative, TesttubeIllustrative, Thermometer1Illustrative, ThermometerIllustrative, TicketIllustrative, Time11Illustrative, Time1Illustrative, Time2Illustrative, TimeIllustrative, TimerIllustrative, ToothIllustrative, Transfusion1Illustrative, TransfusionIllustrative, Truck1Illustrative, Truck2Illustrative, TruckIllustrative, TypewriterIllustrative, UniformIllustrative, UnlockIllustrative, UsbIllustrative, User11Illustrative, User1Illustrative, UserIllustrative, VictoryIllustrative, VideocameraIllustrative, VideoplayerIllustrative, VisaIllustrative, Visualization1Illustrative, VisualizationIllustrative, WatchIllustrative, WeighingscaleIllustrative, Wheelchair1Illustrative, WheelchairIllustrative, WifiIllustrative, WristwatchIllustrative, Writing1Illustrative, Writing2Illustrative, WritingIllustrative, XrayIllustrative, YenIllustrative };
//# sourceMappingURL=index.js.map
